/**
 * Created by robincoburn on 23/09/15.
 */
angular.module('qkr').directive('couponDetails', () => ({
        restrict: 'E',
        scope: {
            model: '=',
            config: '=',
            errors: '=',
            couponForm: '='
        },
        template: require('../../coupons/templates/couponDetails.html'),
        link(scope, element, attrs, ngModel) {
            scope.canEdit = scope.config.canEdit;
            scope.isEdit = scope.config.isEdit;
            scope.maxLength = 255;

            scope.checkMaxlength = function() {
                // We need to manually set a maxlength attribute on our desc and terms textareas
                //	- Using ng-maxlength just gives us undefined if either field exceeds 255 chars
                // so can't get a proper validation message
                //	- Using normal maxlength doesn't count line breaks
                //	- We want it to just not be possible to enter more than 255
                const descriptionTextarea = angular.element('#description');

                if (descriptionTextarea.val().length >= scope.maxLength) {
                    return scope.maxLength;
                } else {
                    return 999;
                }
            };
        }
    })
);



// WEBPACK FOOTER //
// ./src/coupons/directives/couponDetails.js